<template>
    <v-container fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" class="text-center">
           <div v-if="loading">
               <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
               <p class="mt-4 title">Giriş yapılıyor, lütfen bekleyin...</p>
           </div>
            <v-alert v-if="error" type="error">
                Giriş sırasında bir hata oluştu: {{ error }}
                <div class="mt-3">
                    <v-btn color="primary" to="/login">Giriş Sayfasına Dön</v-btn>
                </div>
            </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import { mapActions } from 'vuex';
  
  export default {
    name: 'AuthCallback',
    data() {
        return {
            loading: true,
            error: null,
        };
    },
    methods: {
        ...mapActions('auth', ['handleAuthCallback']),
    },
    async created() {
        const token = this.$route.query.token; // URL'den token'ı al (örn: /auth/callback?token=...)
  
        if (token) {
            try {
                // Vuex action'ını çağırarak token'ı işle ve kullanıcıyı doğrula
                const loggedIn = await this.handleAuthCallback(`Bearer ${token}`); // Bearer formatında gönderelim
                if (loggedIn) {
                     this.$router.push('/'); // Başarılıysa ana sayfaya yönlendir
                } else {
                     throw new Error("Kullanıcı bilgileri alınamadı.");
                }
            } catch (err) {
                console.error("Auth Callback Error:", err);
                this.error = err.message || 'Kimlik doğrulama başarısız oldu.';
                this.loading = false;
            }
        } else {
            this.error = 'Kimlik doğrulama token\'ı bulunamadı.';
            this.loading = false;
             // Token yoksa direkt login'e yönlendirilebilir
             // this.$router.push('/login');
        }
    }
  };
  </script>